import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IndividualRelationshipGroupModel } from "../../models/individual-relationship-group-model";
import { CountryPipe } from "../../../../../../shared/pipes/countryPipe";
import { stateOptions } from "../../../../../../shared/constants/au-states.constant";

type CellRendererParams = ICellRendererParams<IndividualRelationshipGroupModel>;

@Component({
  selector: 'app-ag-individul-pob',
  standalone: true,
  imports: [CountryPipe],
  templateUrl: 'ag-individul-pob.component.html',
  styleUrl: 'ag-individul-pob.component.scss'
})
export class AgIndividulPobComponent implements ICellRendererAngularComp {
  @Input() birthCity = '';
  @Input() birthCountry = '';
  @Input() countryFlag = '';

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  getCountryFlag(): string {
    const country = stateOptions
      .find((option) => option.countryCode === this.birthCountry.toUpperCase()
        || option.label.toLocaleLowerCase() === this.birthCountry.toLocaleLowerCase());
    return country?.flagClass ?? '';
  }

  updateCell(params: CellRendererParams): boolean {
    this.birthCity = params.data?.birthCity ?? '';
    this.birthCountry = params.data?.birthCountry ?? '';
    this.countryFlag = this.getCountryFlag();
    return true;
  }
}
